export default __webpack_public_path__ + "static/media/Gerardo Gándara Resume 2021.72872da1.pdf";